import React, { useState, useEffect, useRef, useCallback } from "react";
import OtpInput from "react-otp-input";
import OtpPageWrapper from "./OtpPageStyle";
import { withTranslation } from "react-i18next";
import { Toast } from "primereact/toast";
import { config } from "../../../../config";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../../redux/actions/travel";
import CountdownTimer from "./CountdownTimer";
import * as travelService from "../../../../services/travel-service";
import * as globalUtils from "../../../../helpers/utils";

const OtpPage = (props) => {
 const { forGoogleTagging = "" } = props;
 const [otp, setOtp] = useState("");
 const dipatch = useDispatch();
 const toast = useRef(null);
 // const [display, setDisplay] = useState(show);
 const [resetCounter, updateResetCounter] = useState(false);
 const [canResend, setCanResend] = useState(false);
 const [loader, setLoader] = useState(false);

 // useEffect(() => {
 //   if (props.show) {
 //     sendOTP();
 //   }
 // }, [props.show]);

 //  for Google tagging (when user shows the otp popup)
//  useEffect(() => {
//   if (props.show) {
//    window.dataLayer = window.dataLayer || [];
//    window.dataLayer.push({
//     event: "travel_new_addOtpBegin_v2",
//     item_name: "Travel Insurance New",
//     item_category: "Travel Insurance",
//     item_class: "Individual",
//     funnel_step: "step_3",
//     travelling_to: forGoogleTagging,
//    });
//   }
//  }, [props.show]);


 const verifyOTP = () => {
  console.log("aaaa")
  props.verifyClicked(otp)
  
 };


 return (
  <Dialog
   visible={props.show}
   showHeader={false}
   closable={true}
   modal={true}
   onHide={props.cancelOTP}
   contentStyle={{ padding: "20px", borderRadius: "10px" }}
  >
   <Toast ref={toast} />
   <OtpPageWrapper>
    <div className="container-fluid">
     <div className="d-flex justify-content-center">
      <div className="col-12 col-sm-12">
       <div className="d-flex justify-content-center">
        <h2 className="otpVerificationTitle">{props.t("otp-verification-title")}</h2>
       </div>
       <div className="d-flex justify-content-center">
        <p className="otpSentMessageStyle">
         {props.t("otp-sent-email")}
         <br />
         {props.t("starting-with")}
         {props.mobileNumber && <span className="lato">*{props.mobileNumber.substring(0,props.mobileNumber.length -9 )}</span>}
        </p>
       </div>
       {/* <h4 className="countdownTextStyle">
        {props.t("remaining-time")}:
        <span className="countdownStyle">
         <CountdownTimer onFinish={() => setCanResend(true)} resetCounter={resetCounter} count={config.otpPeriod} />
        </span>
       </h4> */}
       <div dir="ltr" className="d-flex justify-content-center">
        <OtpInput
         isInputNum={true}
         value={otp}
         onChange={(e) => setOtp(e)}
         placeholder="0000"
         focusStyle={{
          border: "1px solid #EAEAEA",
          outline: "none",
          width: "60px",
          height: "60px",
         }}
         separator={<span>&nbsp;&nbsp;&nbsp;</span>}
         numInputs={4}
         inputStyle="containerStyle lato"
        />
       </div>
       {/* <h3 className="resendOtp text-center">
        {props.t("didnt-receive-otp")}<br/>
        {props.t("to-resend-the-pin")}.
       </h3> */}
       {/* <h3 className="text-center">
       <Button
           className="d-block p-button-text mx-auto my-2"
           disabled={!canResend}
           style={{ color: "#6B47F5" }}
           label={props.t("click-here")}
           onClick={resendOTP}
       />
       </h3> */}
       <div className="d-flex justify-content-center verifyButtonDiv">
        <Button
         className="otpVerifybutton"
         loading={loader}
         type="button"
         iconPos="right"
         onClick={verifyOTP}
         label={props.t("verify")}
        />
       </div>
      </div>
     </div>
    </div>
   </OtpPageWrapper>
  </Dialog>
 );
};

export default withTranslation()(OtpPage);
